var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgebaseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3 0C4.64315 0 3.3 1.34315 3.3 3V3.00025C2.07128 3.00278 1.41604 3.03136 0.933302 3.35391C0.704003 3.50713 0.507127 3.704 0.353914 3.9333C0 4.46297 0 5.20031 0 6.675V16.65C0 18.6299 0 19.6199 0.615076 20.2349C1.23015 20.85 2.2201 20.85 4.2 20.85H12.6C14.5799 20.85 15.5698 20.85 16.1849 20.2349C16.8 19.6199 16.8 18.6299 16.8 16.65V6.675C16.8 5.20031 16.8 4.46297 16.4461 3.9333C16.2929 3.704 16.096 3.50713 15.8667 3.35391C15.384 3.03136 14.7287 3.00278 13.5 3.00025V3C13.5 1.34315 12.1569 0 10.5 0H6.3ZM6.34922 3C6.34922 2.44772 6.79693 2 7.34922 2H9.44922C10.0015 2 10.4492 2.44772 10.4492 3C10.4492 3.55228 10.0015 4 9.44922 4H7.34922C6.79693 4 6.34922 3.55228 6.34922 3ZM5.24844 9.35C4.69615 9.35 4.24844 9.79772 4.24844 10.35C4.24844 10.9023 4.69615 11.35 5.24844 11.35H11.5484C12.1007 11.35 12.5484 10.9023 12.5484 10.35C12.5484 9.79772 12.1007 9.35 11.5484 9.35H5.24844ZM5.24844 13.55C4.69615 13.55 4.24844 13.9977 4.24844 14.55C4.24844 15.1023 4.69615 15.55 5.24844 15.55L9.44844 15.55C10.0007 15.55 10.4484 15.1023 10.4484 14.55C10.4484 13.9977 10.0007 13.55 9.44844 13.55L5.24844 13.55Z",
    fill: "#334D6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgebaseicon);
export default __webpack_public_path__ + "static/media/knowledgebaseicon.4ffdf5f609c5069ded72cc5b5d9b766b.svg";
export { ForwardRef as ReactComponent };